<template>
  <div>
    {{showClosePopUp}}
    <div v-if="showmodal">
      <transition name="modal">
        <div class="modal-mask upl-holdNEW wdth-700" style="overflow-y: auto; display: block;">
          <div class="modal-wrapper">
            <div class="modal-container">
              <!--Modal header-->
              <div class="modal-header">
                <slot name="header" style="border:1px red;">
                  <!-- <h5 class="modal-title">File List</h5> -->
                  <h4 class="modal-title mt-2"></h4>
                  <button
                    type="button"
                    @click.prevent="closePopUp('goBack')"
                    aria-label="Close"
                    class="close up-close"
                  >×</button>
                </slot>
              </div>
              <!--Modal Body-->
              <div class="modal-body">
                <div
                  class="document doc-root fontsize fontface vmargins hmargins pagesize skn-srz5 SRZ5 ZTY"
                  id="resumesec"
                >
                  <div id="CONTAINER_PARENT_0" class="topsection">
                    <div id="CONTAINER_0" class="left-box">
                      <div
                        data-react-beautiful-dnd-draggable="25"
                        class="sortable-item section-container SortableItem-sibling name-contact"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_NAMEd59d17e4-60c0-4277-8636-ef2e458c1273"
                          class="section nameSec notdraggable SECTION_NAME"
                          data-section-cd="NAME"
                        >
                          <div class="doc-item">
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_NAME_b24010c3-154f-4761-9084-06b4bc73dc3a"
                                  class="paragraph PARAGRAPH_NAME firstparagraph"
                                >
                                  <div>
                                    <div class="name">
                                      <span
                                        class="field fName"
                                        id="FIELD_FNAM"
                                      >{{resume.profile.firstname +" "}}</span>
                                      <span dependency="FNAM+LNAM"></span>
                                      <span id="FIELD_LNAM">{{resume.profile.surname}}</span>
                                    </div>
                                    <div
                                      class="resumeTitle"
                                      id="FIELD_DCTL"
                                    >{{resume.profile.profession}}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="SECTION_CNTCc95f3f70-4640-46c0-b6bc-8317d96d8c0f"
                          class="section cntcSec notdraggable SECTION_CNTC"
                          data-section-cd="CNTC"
                        >
                          <div class="doc-item">
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_CNTC_26467dc2-5a9c-1d08-f197-c59503854f4d"
                                  class="paragraph PARAGRAPH_CNTC firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <div class="address">
                                      <div class="addressLeft">
                                        <div
                                          v-if="resume.profile&&resume.profile.email"
                                          dependency="EMAI"
                                        >
                                          <span class="txtBold">
                                            <span class="xslt_static_change">E-mail</span>
                                          </span>
                                          <span id="FIELD_EMAI">{{resume.profile.email}}</span>
                                        </div>
                                      </div>
                                      <div class="addressRight"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="doc-overlay section-overlay" style="left:-2px; right: -2px;">
                          <span></span>
                        </div>
                      </div>
                    </div>
                    <div id="CONTAINER_1" class="right-box">
                      <div
                        data-react-beautiful-dnd-draggable="25"
                        class="sortable-item section-container SortableItem-sibling data-PICT"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_PICTd30c8ce1-c91e-f634-96b9-b012cc22575e"
                          class="section photo notdraggable SECTION_PICT firstsection"
                          data-section-cd="PICT"
                        >
                          <div class="doc-item">
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_PICT_cb014bbd-e262-b84e-e9aa-3470a7ef8a6c"
                                  class="paragraph PARAGRAPH_PICT firstparagraph placeholder-text"
                                >
                                  <div class="clearfix doc-item">
                                    <div class="prflPic">
                                      <div id="FIELD_PURL">
                                        <img
                                          v-if="resume.pic&&resume.pic!=''&&resume.pic!=undefined"
                                          class="chk"
                                          :src="resume.pic"
                                          alt="Smiley face"
                                        >
                                        <img
                                          v-else
                                          class="chk"
                                          src="data:image/png;base64,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"
                                          alt="Smiley face"
                                        >

                                        <a
                                          href="javascript:;"
                                          class="btn btn-primary btn-prfl-edit"
                                          title="Edit Photo"
                                        ></a>
                                      </div>
                                    </div>
                                    <div class="clear"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="CONTAINER_PARENT_1" class="parentContainer">
                    <div id="CONTAINER_2">
                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-SUMM"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_SUMM07668616-5d25-41ea-84c1-a7a1ec9c1df0"
                          class="section summary notdraggable SECTION_SUMM"
                          data-section-cd="SUMM"
                        >
                          <div class="doc-item">
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_SUMM_f8e3743a-09a7-e143-532e-a04c02e72736"
                                  class="paragraph PARAGRAPH_SUMM firstparagraph"
                                >
                                  <div v-if="resume.summary" class="clearfix doc-item">
                                    <div class="field singlecolumn noPind" id="FIELD_FRFM">
                                      <p v-html="resume.summary"></p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-TPFL"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_TPFLb726b65b-7bf7-edc4-d5ab-5857388f0c07"
                          class="section tpfl-sec SECTION_TPFL has-title"
                          data-section-cd="TPFL"
                          v-if="resume.skills"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="scale(1.4) translate(14, 16)"
                                    d="M19.9141 7.17578C20.125 7.49219 20.5117 7.63281 20.8984 7.52734C21.3906 7.35156 21.707 7.21094 22.0938 6.89453C22.4102 6.64844 22.4805 6.19141 22.2695 5.83984L22.1992 5.66406C22.2695 5.55859 22.3398 5.41797 22.4102 5.3125H22.5859C22.9727 5.3125 23.3242 4.99609 23.4297 4.60938C23.5 4.11719 23.5 3.73047 23.4297 3.27344C23.3242 2.85156 23.0078 2.57031 22.5859 2.57031H22.4102C22.3398 2.42969 22.2695 2.32422 22.1992 2.18359L22.2695 2.04297C22.4805 1.69141 22.4102 1.23438 22.0938 0.988281C21.707 0.636719 21.3906 0.460938 20.9336 0.320312C20.5469 0.179688 20.125 0.320312 19.9141 0.671875L19.8438 0.847656C19.7031 0.8125 19.5625 0.8125 19.3867 0.847656L19.3164 0.671875C19.1055 0.320312 18.6836 0.179688 18.2969 0.320312C17.8398 0.460938 17.4883 0.671875 17.1367 0.988281C16.8203 1.23438 16.75 1.69141 16.9609 2.04297L17.0312 2.18359C16.9609 2.32422 16.8906 2.42969 16.8203 2.57031H16.5039C16.1172 2.57031 15.7656 2.85156 15.6953 3.27344C15.5898 3.76562 15.5898 4.11719 15.6602 4.60938C15.7656 4.99609 16.082 5.3125 16.5039 5.3125H16.8203C16.8906 5.41797 16.9609 5.55859 17.0312 5.66406L16.9609 5.83984C16.75 6.19141 16.8203 6.64844 17.1367 6.89453C17.5234 7.21094 17.875 7.38672 18.332 7.52734C18.7188 7.63281 19.1055 7.49219 19.3164 7.17578L19.3867 7.03516C19.5625 7.03516 19.7031 7.03516 19.8438 7.03516L19.9141 7.17578ZM20.3359 5.94531L20.0195 6.01562C19.7383 6.08594 19.4922 6.08594 19.2461 6.01562L18.8945 5.94531L18.5078 6.61328C18.2969 6.50781 18.0508 6.36719 17.875 6.22656L18.2266 5.55859L18.0156 5.3125C17.8398 5.10156 17.6992 4.89062 17.6289 4.64453L17.4883 4.32812H16.75C16.7148 4.04688 16.7148 3.80078 16.75 3.55469H17.4883L17.6289 3.23828C17.6992 2.99219 17.8398 2.74609 18.0156 2.57031L18.2266 2.28906L17.875 1.65625C18.0508 1.48047 18.2969 1.375 18.5078 1.26953L18.8945 1.90234L19.2109 1.86719C19.4922 1.79688 19.7383 1.79688 20.0195 1.86719L20.3359 1.90234L20.7227 1.26953C20.9688 1.375 21.1797 1.48047 21.3906 1.65625L21.0039 2.28906L21.2148 2.57031C21.3906 2.74609 21.5312 2.99219 21.6016 3.23828L21.7422 3.55469H22.4805C22.5156 3.80078 22.5156 4.08203 22.4805 4.32812H21.7422L21.6016 4.64453C21.5312 4.89062 21.3906 5.10156 21.2148 5.3125L21.0039 5.59375L21.3906 6.22656C21.1797 6.36719 20.9688 6.50781 20.7227 6.61328L20.3359 5.94531ZM6.09766 16.2461C6.09766 16.6328 6.37891 16.9844 6.73047 17.0547C8.03125 17.3711 9.01562 17.3711 10.3164 17.0547C10.7031 16.9844 10.9844 16.6328 10.9844 16.2461V15.1211C11.4414 14.9453 11.8633 14.6992 12.2852 14.3828L13.2344 14.9453C13.5859 15.1562 14.0078 15.0859 14.2891 14.8047C15.0977 13.9258 16.0117 12.7656 16.2578 11.6758C16.3281 11.3242 16.1523 10.9375 15.8711 10.7617L14.8867 10.1641C14.9219 9.67188 14.9219 9.14453 14.8867 8.65234L15.7656 8.125C16.082 7.91406 16.2227 7.49219 16.1172 7.14062C15.7305 5.98047 15.2383 5.06641 14.2891 4.01172C14.0078 3.73047 13.5859 3.66016 13.2344 3.87109L12.2852 4.43359C11.8633 4.11719 11.4414 3.87109 10.9844 3.69531V2.57031C10.9844 2.18359 10.7031 1.83203 10.3164 1.76172C8.94531 1.44531 7.96094 1.48047 6.76562 1.76172C6.37891 1.83203 6.09766 2.18359 6.09766 2.57031V3.69531C5.64062 3.87109 5.21875 4.11719 4.79688 4.43359L3.84766 3.87109C3.49609 3.66016 3.07422 3.73047 2.79297 4.01172C1.94922 4.96094 1.45703 5.76953 1.03516 7.14062C0.894531 7.49219 1.07031 7.91406 1.38672 8.125L2.37109 8.65234C2.30078 9.14453 2.30078 9.63672 2.37109 10.1289L1.38672 10.6914C1.07031 10.9023 0.894531 11.3242 1.03516 11.6758C1.45703 13.0469 1.94922 13.8555 2.79297 14.7695C3.07422 15.0859 3.49609 15.1562 3.84766 14.9453L4.79688 14.3828C5.21875 14.6992 5.64062 14.9453 6.09766 15.1211V16.2461ZM7.22266 16.0352V14.3477L6.83594 14.207C6.23828 13.9961 5.71094 13.6797 5.21875 13.293L4.9375 13.0117L3.46094 13.8555C2.86328 13.1875 2.44141 12.4141 2.16016 11.5703L3.60156 10.7266L3.53125 10.3398C3.42578 9.70703 3.42578 9.10938 3.53125 8.47656L3.60156 8.08984L2.16016 7.24609C2.37109 6.54297 2.96875 5.52344 3.46094 4.96094L4.9375 5.80469L5.21875 5.52344C5.71094 5.13672 6.23828 4.82031 6.83594 4.60938L7.22266 4.46875V2.78125C8.10156 2.60547 8.98047 2.60547 9.85938 2.78125V4.46875L10.2461 4.60938C10.8438 4.82031 11.3711 5.10156 11.8633 5.52344L12.1445 5.80469L13.6211 4.96094C14.2188 5.62891 14.8164 6.40234 15.0977 7.24609L13.6211 8.08984L13.7266 8.47656C13.832 9.07422 13.832 9.70703 13.7266 10.3398L13.6211 10.7266L15.0977 11.5703C14.8164 12.4141 14.2188 13.1875 13.6211 13.8555L12.1445 13.0117L11.8633 13.293C11.3711 13.6797 10.8438 13.9961 10.2461 14.207L9.85938 14.3477V16.0352C8.98047 16.2109 8.10156 16.2109 7.22266 16.0352ZM8.55859 12.3086C10.1758 12.3086 11.4766 11.0078 11.4766 9.39062C11.4766 7.80859 10.1758 6.50781 8.55859 6.50781C6.97656 6.50781 5.64062 7.80859 5.64062 9.39062C5.64062 11.0078 6.97656 12.3086 8.55859 12.3086ZM8.55859 7.63281C9.54297 7.63281 10.3516 8.40625 10.3516 9.39062C10.3516 10.4102 9.54297 11.1836 8.55859 11.1836C7.57422 11.1836 6.76562 10.4102 6.76562 9.39062C6.76562 8.40625 7.57422 7.63281 8.55859 7.63281ZM19.9141 17.8633C20.125 18.1797 20.5117 18.3555 20.8984 18.2148C21.3906 18.0742 21.707 17.8984 22.0938 17.582C22.4102 17.3359 22.4805 16.8789 22.2695 16.5273L22.1992 16.3867C22.2695 16.2461 22.3398 16.1406 22.4102 16H22.5859C22.9727 16 23.3242 15.7188 23.4297 15.332C23.5 14.8047 23.5 14.4531 23.4297 13.9609C23.3242 13.5742 23.0078 13.2578 22.5859 13.2578H22.4102C22.3398 13.1523 22.2695 13.0117 22.1992 12.9062L22.2695 12.7305C22.4805 12.3789 22.4102 11.957 22.0938 11.6758C21.707 11.3594 21.3906 11.1836 20.9336 11.0078C20.5469 10.8672 20.125 11.043 19.9141 11.3945L19.8438 11.5352C19.7031 11.5352 19.5625 11.5352 19.3867 11.5352L19.3164 11.3945C19.1055 11.043 18.6836 10.8672 18.2969 11.0078C17.8398 11.1836 17.4883 11.3594 17.1367 11.6758C16.8203 11.957 16.75 12.3789 16.9609 12.7305L17.0312 12.9062C16.9609 13.0117 16.8906 13.1523 16.8203 13.2578H16.5039C16.1172 13.2578 15.7656 13.5742 15.6953 13.9609C15.5898 14.4531 15.5898 14.8398 15.6602 15.2969C15.7656 15.7188 16.082 16 16.5039 16H16.8203C16.8906 16.1406 16.9609 16.2461 17.0312 16.3867L16.9609 16.5273C16.75 16.8789 16.8203 17.3359 17.1367 17.582C17.5234 17.9336 17.875 18.0742 18.332 18.2148C18.7188 18.3555 19.1055 18.2148 19.3164 17.8633L19.3867 17.7227C19.5625 17.7578 19.7031 17.7578 19.8438 17.7227L19.9141 17.8633ZM20.3359 16.668L20.0195 16.7031C19.7383 16.7734 19.4922 16.7734 19.2461 16.7031L18.8945 16.668L18.5078 17.3008C18.2969 17.1953 18.0508 17.0898 17.875 16.9141L18.2266 16.2812L18.0156 16C17.8398 15.8242 17.6992 15.5781 17.6289 15.332L17.4883 15.0156H16.75C16.7148 14.7695 16.7148 14.5234 16.75 14.2422H17.4883L17.6289 13.9258C17.6992 13.6797 17.8398 13.4688 18.0156 13.2578L18.2266 13.0117L17.875 12.3438C18.0508 12.2031 18.2969 12.0625 18.5078 11.957L18.8945 12.625L19.2461 12.5547C19.4922 12.5195 19.7383 12.5195 20.0195 12.5547L20.3359 12.625L20.7227 11.957C20.9688 12.0625 21.1797 12.2031 21.3906 12.3438L21.0039 13.0117L21.2148 13.2578C21.3906 13.4688 21.5312 13.6797 21.6016 13.9258L21.7422 14.2422H22.4805C22.5156 14.5234 22.5156 14.7695 22.4805 15.0156H21.7422L21.6016 15.332C21.5312 15.5781 21.3906 15.8242 21.2148 16L21.0039 16.2812L21.3906 16.9141C21.1797 17.0898 20.9688 17.1953 20.7227 17.3008L20.3359 16.668ZM20.6875 14.5938C20.6875 13.9961 20.1602 13.4688 19.5625 13.4688C18.9297 13.4688 18.4375 13.9961 18.4375 14.5938C18.4375 15.2266 18.9297 15.7188 19.5625 15.7188C20.1602 15.7188 20.6875 15.2266 20.6875 14.5938ZM20.6875 3.90625C20.6875 3.27344 20.1602 2.78125 19.5625 2.78125C18.9297 2.78125 18.4375 3.27344 18.4375 3.90625C18.4375 4.53906 18.9297 5.03125 19.5625 5.03125C20.1602 5.03125 20.6875 4.53906 20.6875 3.90625Z"
                                    fill="white"
                                  ></path>
                                </svg>
                              </div>
                              <div v-if="resume.skills" class="sectiontitle" id="SECTIONNAME_TPFL">
                                Technical Profile
                                <span
                                  title="Rename Technical Profile section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_TPFL_228592b6-36ac-4331-d5a8-2b6847498a9f"
                                  class="paragraph PARAGRAPH_TPFL firstparagraph"
                                >
                                  <div v-if="resume.skills" class="clearfix doc-item">
                                    <div
                                      class="singlecolumn maincolumn noPind"
                                      v-html="resume.skills"
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-HILT"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_HILT09431c3c-31fc-47c0-bb9c-f1e0983a63e5"
                          class="section SECTION_HILT has-title"
                          data-section-cd="HILT"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M31.36 14.293l-3.413-3.413c2.133-.64 3.84-2.773 3.84-5.333C31.787 2.56 29.227 0 26.24 0c-2.347 0-4.48 1.707-5.333 3.84l-3.2-3.2c-.854-.853-2.56-.853-3.414 0L9.6 5.333c-.213.427-.213.854-.213 1.28.213.427.64.64 1.066.427h.64c2.134 0 3.84 1.707 3.84 4.053 0 2.134-1.493 4.054-3.84 4.054-2.133 0-4.053-1.92-4.053-4.054v-.64a1.63 1.63 0 0 0-.427-1.066c-.213-.427-.64-.427-.853 0L.64 14.293c-.853.854-.853 2.347 0 3.414L14.293 31.36c.427.427 1.067.64 1.707.64.64 0 1.28-.213 1.707-.64L31.36 17.707c.853-.854.853-2.56 0-3.414zm-1.493 1.92L16.213 29.867c-.213.213-.426.213-.64 0L2.133 16.213c-.213 0-.213-.426 0-.426l3.414-3.414a5.953 5.953 0 0 0 5.76 4.48c3.2 0 5.76-2.56 5.76-5.973 0-2.773-1.707-5.12-4.267-5.76l2.987-2.987c.213-.213.426-.213.64 0l4.906 4.907c.214.213.854.427 1.067.213.427-.213.64-.64.64-1.066v-.214-.213c0-1.92 1.493-3.413 3.413-3.413 1.92 0 3.414 1.493 3.414 3.413 0 1.92-1.494 3.413-3.414 3.413h-.426c-.427 0-.854.214-1.067.64-.213.427-.213.854.213 1.067l4.694 4.907c.213 0 .213.426 0 .426z"
                                  ></path>
                                </svg>
                              </div>
                              <div class="sectiontitle" id="SECTIONNAME_HILT">
                                Competencies
                                <span
                                  title="Rename Competencies section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class="sortableInner">
                                <div
                                  id="PARAGRAPH_HILT_314d767b-c23e-979e-749e-a4b4d12e1d28"
                                  class="paragraph PARAGRAPH_HILT firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <div class="singlecolumn maincolumn noPind">
                                      <span class="ratingfield" id="FIELD_SKC1">
                                        <p>Project budgeting</p>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  id="PARAGRAPH_HILT_e0adcbd3-d033-857e-b870-fa260cacaec0"
                                  class="paragraph PARAGRAPH_HILT"
                                >
                                  <div class="clearfix doc-item">
                                    <div class="singlecolumn maincolumn noPind">
                                      <span class="ratingfield" id="FIELD_SKC1">
                                        <p>Solutions deployment</p>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-------WORK EXP---------->

                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-EXPR"
                        v-if="resume.workExperience"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_EXPR21985c04-1ed9-4db8-999c-40b5418c124f"
                          class="section SECTION_EXPR multi-para has-title"
                          data-section-cd="EXPR"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M30 5.983h-7.987V4.045c0-1.655-1.345-3-3-3h-6.015c-1.655 0-3 1.345-3 3v1.938H2.001C.9 5.983 0 6.883 0 7.982V28.953c0 1.1.9 2.001 2 2.001h28c1.099 0 2-.9 2-2V7.981a2.008 2.008 0 0 0-2-1.999zM12 4.045c0-.551.447-1 1-1h6.011c.55 0 1 .447 1 1v1.938H12V4.045zM2 7.982h28v7.008H18.986v-1.025c0-1.101-.897-2-1.998-2h-1.993c-1.101 0-2 .897-2 2v1.025H2V7.982zm14.989 11.02h-1.993v-5.037h1.993v5.037zM2 28.951V16.988h10.997V19c0 1.102.897 2 2 2h1.99a2.002 2.002 0 0 0 2-2v-2.01h11.011v11.963H2.001z"
                                  ></path>
                                </svg>
                              </div>
                              <div
                                v-if="resume.workExperience"
                                class="sectiontitle"
                                id="SECTIONNAME_EXPR"
                              >
                                Work History
                                <span
                                  title="Rename Work History section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_EXPR_7ccfce7a-e234-7b77-eb54-149b4dd879a5"
                                  class="paragraph PARAGRAPH_EXPR firstparagraph"
                                  v-for="(item,index) in resume.workExperience"
                                >
                                  <div class="clearfix doc-item">
                                    <span class="dates_wrapper">
                                      <span
                                        class="jobdates"
                                        id="FIELD_JSTD"
                                        format="%b %Y"
                                      >{{ item.startdate }}</span>
                                      <span dependency="JSTD+EDDT">-</span>
                                      <span
                                        class="jobdates"
                                        id="FIELD_EDDT"
                                        format="%b %Y"
                                      >{{ item.enddate }}</span>
                                    </span>
                                    <div class="singlecolumn">
                                      <span class="paddedline pb5" dependency="JTIT">
                                        <span class="jobtitle" id="FIELD_JTIT">{{ item.jobtitle }}</span>
                                      </span>
                                      <span
                                        class="paddedline txtItalics pb5"
                                        dependency="COMP|JSTA|JCIT"
                                      >
                                        <span
                                          class="companyname"
                                          id="FIELD_COMP"
                                        >{{ item.employer }}</span>
                                        <span dependency="COMP+JCIT|JSTA">,</span>
                                        <span
                                          class="joblocation jobcity"
                                          id="FIELD_JCIT"
                                        >{{ item.city }}</span>
                                        <span
                                          class="joblocation jobstate"
                                          id="FIELD_JSTA"
                                        >{{ item.country }}</span>
                                      </span>
                                      <span class="paddedline">
                                        <span
                                          class="jobline"
                                          id="FIELD_JDES"
                                          v-html="item.description"
                                        ></span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--WORK-->

                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-EDUC"
                        v-if="resume.education"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_EDUC3400955b-657f-4705-b46e-309b209f6970"
                          class="section SECTION_EDUC multi-para has-title"
                          data-section-cd="EDUC"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M30.96 22.58v-9.217l.503-.303c.327-.194.533-.58.537-1 .004-.421-.196-.81-.518-1.014L16.44 1.848a.893.893 0 0 0-.967.004l-14.96 9.21c-.318.202-.515.587-.513 1.005.002.417.203.8.525.998l6.573 3.999a1.256 1.256 0 0 0-.133.56v9.669c0 .325.122.637.335.853.217.22 2.294 2.146 8.646 2.146 6.33 0 8.463-1.82 8.686-2.028a1.21 1.21 0 0 0 .367-.884v-9.917c0-.16-.03-.313-.082-.452l4.044-2.441v8.016c-.593.396-.995 1.124-.995 1.965 0 1.262.895 2.285 2 2.285 1.104 0 1.999-1.023 1.999-2.285 0-.845-.407-1.576-1.005-1.97zM23 26.725c-.787.432-2.866 1.282-7.054 1.282-4.214 0-6.246-.905-6.982-1.34v-8.468l6.493 3.95a.892.892 0 0 0 .937.006L23 18.17v8.556zm-7.06-6.876L3.08 12.045l12.881-7.89 12.922 7.868L15.94 19.85z"
                                  ></path>
                                </svg>
                              </div>
                              <div class="sectiontitle" id="SECTIONNAME_EDUC">
                                Education
                                <span
                                  title="Rename Education section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <!--EDUCATION-->

                                <div
                                  id="PARAGRAPH_EDUC_485b0029-d439-43a4-199f-c330cdcdb5af"
                                  class="paragraph PARAGRAPH_EDUC firstparagraph"
                                  v-for="(item,index) in resume.education"
                                >
                                  <div class="clearfix doc-item">
                                    <span class="dates_wrapper">
                                      <span
                                        class="jobdates"
                                        id="FIELD_GRST"
                                        format="%b %Y"
                                      >{{ item.grad_startdate }}</span>
                                      <span dependency="GRST+GRED">-</span>
                                      <span
                                        class="jobdates"
                                        id="FIELD_GRED"
                                        format="%b %Y"
                                      >{{ item.grad_enddate }}</span>
                                    </span>
                                    <div class="singlecolumn">
                                      <span class="paddedline" dependency="DGRE|STUY">
                                        <span class="degree" id="FIELD_DGRE">{{ item.degree }}</span>
                                        <span dependency="DGRE+STUY" class="degree">:</span>
                                        <span class="programline" id="FIELD_STUY">{{ item.field }}</span>
                                      </span>
                                      <span
                                        class="paddedline txtItalics"
                                        dependency="SCHO|SCIT|SSTA"
                                      >
                                        <span
                                          class="companyname companyname_educ"
                                          dependency="SCHO"
                                          id="FIELD_SCHO"
                                        >{{ item.school_name }}</span>
                                        <span class="statesWrapper" dependency="SCHO+SCIT|SSTA">-</span>
                                        <span
                                          class="joblocation jobcity"
                                          id="FIELD_SCIT"
                                        >{{ item.school_location }}</span>
                                        <span class="joblocation jobstate" id="FIELD_SSTA"></span>
                                      </span>
                                      <span class="paddedline">
                                        <span id="FIELD_FRFM" v-html="item.description"></span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <!--EDUCATION-->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="resume.extraFields.accomplishments_text!='None'"
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-ACCM"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_ACCM711e8d63-fd13-7a9b-fc20-ae05a29ddf9e"
                          class="section SECTION_ACCM has-title"
                          data-section-cd="ACCM"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M32 7.438c0 5.312-5.25 9.437-8.375 11.5-.063.062-.125.187-.188.25 0 0-.187.25-1.375 1.75-.875 1.25-1.812 2.812-1.812 4.687 0 1.5 1.25 3.063 2.563 4.25h2.812V32H6.375v-2.125h2.813c1.312-1.188 2.562-2.75 2.562-4.25 0-1.688-.938-3.375-1.75-4.625-.563-.625-1-1.25-1.438-1.938C5.5 17.063 0 12.875 0 7.5 0 4 2.688 3.312 4.25 3.25c-.063-2 0-3.25 0-3.25h23.5s.063 1.25 0 3.188c1.563.124 4.25.75 4.25 4.25zM2.125 7.5c.25 3.563 2.875 6.563 4.688 8.188-1.5-3.563-2.125-7.376-2.375-10.376-1 .063-2.438.5-2.313 2.188zm23.5-5.375H6.375s-.563 11.188 4.875 17.5c.75 1 2.625 4.563 2.625 6 0 2.625-2.125 4.25-2.125 4.25h8.5s-2.125-1.688-2.125-4.25c0-3.313 2.813-6.375 2.813-6.375 5.187-5.5 4.687-17.125 4.687-17.125zm2 3.188c-.25 3-.75 6.75-2.063 10 1.75-1.688 4.125-4.5 4.313-7.876.125-1.687-1.25-2.062-2.25-2.125z"
                                  ></path>
                                </svg>
                              </div>

                              <div class="sectiontitle" id="SECTIONNAME_ACCM">
                                Accomplishments
                                <span
                                  title="Rename Accomplishments section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_ACCM_f0a09815-8a6a-185c-74a6-6b273f4d7489"
                                  class="paragraph PARAGRAPH_ACCM firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <div
                                      class="field singlecolumn noPind"
                                      id="FIELD_FRFM"
                                      v-html="resume.extraFields.accomplishments_text"
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-AFIL"
                        v-if="resume.extraFields.affiliations_text!='None'"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_AFILa6d10b43-49b0-ac56-062d-88b5e4616cd7"
                          class="section SECTION_AFIL has-title"
                          data-section-cd="AFIL"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M16 32C7.187 32 0 24.812 0 16 0 7.187 7.188 0 16 0c8.813 0 16 7.188 16 16 0 8.813-7.188 16-16 16zm0-29.875A13.844 13.844 0 0 0 2.125 16c0 7.625 6.188 13.875 13.875 13.875 7.625 0 13.875-6.25 13.875-13.875 0-7.688-6.25-13.875-13.875-13.875zm0 24.563c-5.875 0-10.688-4.813-10.688-10.688 0-5.875 4.813-10.688 10.688-10.688 5.875 0 10.688 4.813 10.688 10.688 0 5.875-4.813 10.688-10.688 10.688zm0-2.188a8.253 8.253 0 0 0 3.875-.938l-3.063-3.375c-.25.063-.562.063-.812.063s-.563 0-.813-.063l-3.062 3.375c1.125.625 2.5.938 3.875.938zM7.437 16c0 2.5 1.125 4.75 2.875 6.313l2.126-3.938a5.014 5.014 0 0 1-.688-2.125L7.625 14.5c-.125.5-.188 1-.188 1.5zm.625-3.188l4.5.688c.438-.563.938-1 1.563-1.313l.813-4.624c-3.126.375-5.688 2.437-6.876 5.25zM13.875 16c0 1.188.938 2.125 2.125 2.125A2.107 2.107 0 0 0 18.125 16 2.107 2.107 0 0 0 16 13.875 2.107 2.107 0 0 0 13.875 16zm3.188-8.438l.812 4.625c.625.313 1.125.75 1.563 1.313l4.437-.688C22.75 10 20.187 7.939 17.062 7.563zm3.187 8.688c-.063.75-.313 1.5-.688 2.125l2.125 3.938A8.41 8.41 0 0 0 24.5 16c0-.5 0-1-.125-1.5z"
                                  ></path>
                                </svg>
                              </div>

                              <div class="sectiontitle" id="SECTIONNAME_AFIL">
                                Affiliations
                                <span
                                  title="Rename Affiliations section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_AFIL_6fa310c6-2151-bbce-a852-824a51f6667f"
                                  class="paragraph PARAGRAPH_AFIL firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <div
                                      class="field singlecolumn noPind"
                                      id="FIELD_FRFM"
                                      v-html="resume.extraFields.affiliations_text"
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-ADDI"
                        v-if="resume.extraFields.additional_information_text!='None'"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_ADDIfffbcf09-7b60-07be-7583-88f26543d70e"
                          class="section SECTION_ADDI has-title"
                          data-section-cd="ADDI"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M32 11.595c-.229-.455-.457-.682-.914-.682H20.343L16.914.683C16.914.226 16.457 0 16 0s-.914.227-.914.682l-3.429 10.231H.914c-.228 0-.685.227-.914.682 0 .455 0 .91.457 1.137l8.457 6.593L5.03 30.693c-.229.454 0 .91.457 1.136.457.228.914.228 1.143 0L16 25.01l9.371 6.593c.229.227.458.227.686.227.229 0 .457 0 .686-.227.457-.227.457-.682.457-1.137l-3.886-11.367 8.457-6.594c.229 0 .229-.454.229-.909zM3.886 12.959h7.085L9.6 17.28l-5.714-4.32zM24 28.192l-7.543-5.23c-.228-.227-.457-.227-.686-.227-.228 0-.457 0-.685.228L8 28.192l8-24.1 8 24.1zm-1.6-10.913l-1.371-4.32h7.085L22.4 17.28z"
                                  ></path>
                                </svg>
                              </div>
                              <div class="sectiontitle" id="SECTIONNAME_ADDI">
                                Additional Information
                                <span
                                  title="Rename Additional Information section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_ADDI_0cc275fd-4d2c-9ae8-240c-50050c73f68a"
                                  class="paragraph PARAGRAPH_ADDI firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <div class="field singlecolumn noPind" id="FIELD_FRFM">
                                      <p v-html="resume.extraFields.additional_information_text"></p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-SFTR"
                        v-if="resume.extraFields.software_text!='None'"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_SFTR14fcc652-fb68-c8b9-c401-ea9cd33f2937"
                          class="section SECTION_SFTR has-title"
                          data-section-cd="SFTR"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M30.08 2.986H1.92C.853 2.986 0 3.84 0 4.906v17.067c0 1.067.853 1.92 1.92 1.92h13.013v2.987h-4.906c-.64 0-1.067.426-1.067 1.066 0 .64.427 1.067 1.067 1.067h11.946c.64 0 1.067-.427 1.067-1.067 0-.64-.427-1.066-1.067-1.066h-4.906v-2.987H30.08c1.067 0 1.92-.853 1.92-1.92V4.906c0-1.066-.853-1.92-1.92-1.92zm0 18.987H1.92V4.906h27.947v17.067z"
                                  ></path>
                                </svg>
                              </div>
                              <div class="sectiontitle" id="SECTIONNAME_SFTR">
                                Software
                                <span
                                  title="Rename Software section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_SFTR_14947145-e7d7-5362-5241-8cd603369fd0"
                                  class="paragraph PARAGRAPH_SFTR firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <div class="singlecolumn maincolumn noPind">
                                      <span class="field ratingfield" id="FIELD_FRFM">
                                        <p v-html="resume.extraFields.software_text"></p>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-LANG"
                        v-if="resume.extraFields.languages_text!='None'"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_LANG3d8f17f5-e361-b880-e21b-c0cb9d789dd4"
                          class="section SECTION_LANG has-title"
                          data-section-cd="LANG"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M21.101 3.014C16.231 3.014 14.841 0 8.58 0 4.638 0 2.087 3.246 2.087 3.246v27.826c0 .464.464.928.928.928.463 0 .927-.464.927-.928V18.32c1.16-.696 2.55-1.391 4.406-1.391 6.26 0 8.116 3.014 12.985 3.014 4.87 0 8.58-3.014 8.58-3.014V0s-3.71 3.014-8.812 3.014zM27.826 16c-1.16.696-3.478 2.087-6.493 2.087-1.855 0-3.246-.464-4.87-1.16-2.086-.927-4.405-1.855-8.115-1.855-1.623 0-3.015.232-4.174.928V3.942c.696-.696 2.319-1.855 4.638-1.855 3.014 0 4.637.696 6.26 1.391 1.624.696 3.479 1.623 6.261 1.623 2.551 0 4.87-.695 6.725-1.623V16z"
                                  ></path>
                                </svg>
                              </div>
                              <div class="sectiontitle" id="SECTIONNAME_LANG">
                                Languages
                                <span
                                  title="Rename Languages section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_LANG_63d09b6c-be36-38af-91bb-562b427d033c"
                                  class="paragraph PARAGRAPH_LANG firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <div class="singlecolumn maincolumn noPind">
                                      <span class="field ratingfield" id="FIELD_FRFM">
                                        <p v-html="resume.extraFields.languages_text"></p>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-CERT"
                        v-if="resume.extraFields.certifications_text!='None'"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_CERTd05ce200-caae-56ac-e302-8a463e2e483d"
                          class="section SECTION_CERT has-title"
                          data-section-cd="CERT"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M31.872 26.24l-5.785-10.88c.643-1.28.857-2.773.857-4.48C26.944 4.907 22.016 0 16.016 0c-6 0-10.927 4.907-10.927 10.88 0 1.707.428 3.2 1.071 4.48l-6 10.667c-.214.426-.214.853 0 1.066.215.427.643.64 1.072.64l4.928-1.066 1.714 4.693c.214.213.429.64.857.64.429 0 .643-.213.857-.427l5.143-9.6h2.142l5.143 9.6c.214.427.428.427.857.427.428 0 .643-.213.857-.64l1.714-4.693 4.928 1.066c.429 0 .857 0 1.071-.426.643-.427.643-.854.429-1.067zM9.16 28.587l-1.286-3.414c-.214-.426-.643-.853-1.071-.64l-3.643.854 4.286-7.68c1.5 1.92 3.428 3.2 5.785 4.053L9.16 28.587zm6.856-8.747c-4.928 0-8.999-4.053-8.999-8.96 0-4.907 4.071-8.96 9-8.96 4.927 0 8.998 4.053 8.998 8.96 0 4.907-4.07 8.96-8.999 8.96zm9.428 4.48c-.429-.213-1.071.213-1.071.64l-1.286 3.627-3.857-7.04c2.357-.64 4.5-2.134 5.785-4.054l4.286 7.68-3.857-.853z"
                                  ></path>
                                </svg>
                              </div>
                              <div class="sectiontitle" id="SECTIONNAME_CERT">
                                Certifications
                                <span
                                  title="Rename Certifications section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_CERT_5b651c5c-ecff-34c0-a61b-8a3f86912397"
                                  class="paragraph PARAGRAPH_CERT firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <span class="dates_wrapper">
                                      <span class="jobdates" id="FIELD_DATE" format="%b %Y"></span>
                                    </span>
                                    <div class="singlecolumn">
                                      <span class="paddedline field" id="FIELD_FRFM">
                                        <p v-html="resume.extraFields.certifications_text"></p>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-INTR"
                        v-if="resume.extraFields.interests_text!='None'"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_INTR2e6ebb75-a8d4-bb88-020a-7ba9b0c87825"
                          class="section SECTION_INTR has-title"
                          data-section-cd="INTR"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M16 0c-2.185 0-4.267.441-6.165 1.237a1.01 1.01 0 0 0-.194.085C3.974 3.785 0 9.437 0 16c0 8.823 7.178 16 16 16 8.823 0 16-7.177 16-16 0-8.822-7.177-16-16-16zm13.999 16c0 .112-.006.223-.009.334-1.532-.406-5.42-1.17-10.217-.116a48.942 48.942 0 0 0-1.415-2.965l-.131-.248c5.131-1.981 7.313-4.649 8.215-6.315A13.944 13.944 0 0 1 30 16zM24.927 5.227c-.466 1.1-2.159 3.94-7.651 6-2.467-4.51-4.385-7.212-5.459-8.587A13.948 13.948 0 0 1 16 2c3.391 0 6.503 1.213 8.928 3.226zM9.874 3.416c.85 1.04 2.825 3.66 5.474 8.456-6.253 1.885-11.332 1.659-13.095 1.495.838-4.383 3.723-8.046 7.62-9.951zM2 16c0-.216.006-.43.016-.643.602.06 1.537.128 2.761.128 2.717 0 6.808-.337 11.538-1.819l.267.51c.452.868.86 1.725 1.232 2.565a23.32 23.32 0 0 0-2.623 1c-5.71 2.586-8.385 6.275-9.337 7.89A13.945 13.945 0 0 1 2 16zm5.373 11.013c.508-.962 2.833-4.818 8.643-7.449a20.841 20.841 0 0 1 2.576-.967c1.9 4.825 2.558 8.804 2.757 10.337A13.92 13.92 0 0 1 16 29.999a13.923 13.923 0 0 1-8.626-2.986zm15.867.963c-.288-1.925-1.005-5.545-2.688-9.869 4.642-.924 8.316-.018 9.243.253a14.031 14.031 0 0 1-6.554 9.617z"
                                  ></path>
                                </svg>
                              </div>
                              <div class="sectiontitle" id="SECTIONNAME_INTR">
                                Interests
                                <span
                                  title="Rename Interests section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_INTR_49a87ccf-c300-ef51-7c88-b1cc0e078cad"
                                  class="paragraph PARAGRAPH_INTR firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <div class="field singlecolumn noPind" id="FIELD_FRFM">
                                      <p v-html="resume.extraFields.interests_text"></p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        data-react-beautiful-dnd-draggable="26"
                        class="sortable-item section-container SortableItem-sibling data-CUST"
                        v-if="resume.extraFields.add_your_own_text!='None'&&resume.extraFields.add_your_own_title!='None'"
                      >
                        <div class="document-tool sec-tool" id="editIcons" style="right: -2px;"></div>
                        <div
                          id="SECTION_CUSTe794356c-59b8-b051-9c67-fbfa9e469a23"
                          class="section SECTION_CUST has-title"
                          data-section-cd="CUST"
                        >
                          <div class="doc-item">
                            <div class="heading">
                              <div class="headingIcon">
                                <svg viewBox="0 0 80 80">
                                  <rect x="28" y="-28" height="50" width="50"></rect>
                                  <path
                                    transform="translate(23,19)"
                                    d="M11.907 19.287v9.55l5.891-5.023L32 32l-8.186-14.202 6.077-5.891H19.287l-5.085-5.21 2.232-2.232L11.97 0 0 11.969l4.465 4.465 2.233-2.232zm14.822 7.442l-7.442-4.403 3.039-3.04zM24.62 14.016l-10.604 9.55v-5.333l-5.768-5.52 4.465-4.527 5.52 5.83h6.387zm-20.155-.559L2.977 11.97l8.992-8.992 1.488 1.488z"
                                  ></path>
                                </svg>
                              </div>
                              <div class="sectiontitle" id="SECTIONNAME_CUST">
                                {{resume.extraFields.add_your_own_title}}
                                <span
                                  title="Rename Hobby section"
                                  class="rename-section text-rename"
                                ></span>
                              </div>
                            </div>
                            <div class>
                              <div class>
                                <div
                                  id="PARAGRAPH_CUST_08c9380a-f3d3-7157-05e9-859128f5af1a"
                                  class="paragraph PARAGRAPH_CUST firstparagraph"
                                >
                                  <div class="clearfix doc-item">
                                    <div class="field singlecolumn noPind" id="FIELD_FRFM">
                                      <p>{{resume.extraFields.add_your_own_text}}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="final">
                  <div style="text-align: right" class="signin-btn-hold">
                    <a
                      href="#"
                      class="primary-btn ripple signin-btn"
                      @click.prevent="saveResume"
                    >Save</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="loader">
      <div class="processing_popup upload full-spinner" style="visibility: visible">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <Messages
        v-if="isdisplaymsg"
        :iserror="iserrormsg"
        :datamessage="sucessmsgtext"
        v-on:closemsg="closeMessage"
        v-bind:isVisible="isdisplaymsg"
      ></Messages>
    </transition>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import AWS from "aws-sdk";
import axios from "axios";
import rest_service from "@/api/rest_service_api.js";
import Messages from "@/components/MessagePopup/Messages";
export default {
  name: "Resumeone",
  components: { Messages },
  props: ["resume", "showlist", "parentObj", "final", "from"],
  data() {
    return {
      showmodal: false,
      isdisplaymsg: false,
      sucessmsgtext: "",
      loader: false
    };
  },
  computed: {
    showClosePopUp() {
      var self = this;
      self.showmodal = self.showlist;
    }
  },
  methods: {
    closePopUp: function(item) {
      if (item === "goBack") {
        if (this.parentObj.$data.showResume) {
          this.parentObj.$data.showResume = false;
        }
      }
    },
    closeMessage() {
      this.isdisplaymsg = false;
      // this.iserrormsg = false;
    },
    async saveResume() {
      debugger;
      var self = this;
      var uid;
      if (localStorage.getItem("loggedinuserobj")) {
        uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      }
      const pdfContent =
        "<!DOCTYPE html><html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'/><style type='text/css' id='static'>@font-face { font-family: 'Century Gothic'; font-weight: normal; font-style: normal; src: local('Century Gothic'), url('/blobcontent/zty/fonts/CenturyGothic.ttf') format('truetype'); } @font-face { font-family: 'Century Gothic'; font-weight: bold; font-style: normal; src: local('Century Gothic Bold'), url('/blobcontent/zty/fonts/CenturyGothicBold.ttf') format('truetype'); } @font-face { font-family: 'Century Gothic'; font-weight: bold; font-style: italic; src: local('Century Gothic Bold Italic'), url('/blobcontent/zty/fonts/CenturyGothicBoldItalic.ttf') format('truetype'); } @font-face { font-family: 'Century Gothic'; font-weight: normal; font-style: italic; src: local('Century Gothic Italic'), url('/blobcontent/zty/fonts/CenturyGothicItalic.ttf') format('truetype'); } html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td { margin: 0; padding: 0; border: 0; outline: 0; vertical-align: baseline; background: transparent; } body { text-align: left; font-feature-settings: 'liga' 0; -moz-font-feature-settings: 'liga' off; } .skn-srz5 ol, .skn-srz5 ul { list-style: none; } .skn-srz5 table { border-collapse: collapse; border-spacing: 0; font-size: inherit; color: inherit; width: 100%; } /*START content disc style for LI*/ .skn-srz5 ul, .skn-srz5 li { margin: 0; padding: 0; list-style-type: disc; } .skn-srz5 ul li { margin: 0 0 0 16px; padding: 0; } @-moz-document url-prefix() { .skn-srz5 ul li { margin: 0 0 0 12px; padding: 0 0 0 3px; } } /*END content disc style for LI*/ .skn-srz5 span.paddedline { display: block; } .skn-srz5 span.jobtitle, .skn-srz5 span.degree, .skn-srz5 span.programline { font-weight: bold; } .skn-srz5 .pb5 { padding-bottom: 5px; } .skn-srz5 span.dates_wrapper { font-weight: bold; display: block; float: left; text-align: left; padding-right: 10px; box-sizing: border-box; } .skn-srz5 .txtItalics { font-style: italic; } .skn-srz5 .txtBold { font-weight: bold; } /*table style*/ .skn-srz5 table.skills, .table_wrapper { width: 100%; margin-top: 0; word-wrap: break-word; } .skn-srz5 table.skills th, table.skills td { width: 20%; text-align: center; } .skn-srz5 table.skills .skillname, .skn-srz5 table.skills .skillrating { text-align: left; width: 35%; } .skn-srz5 table.skills .skillrating { width: 20%; } .skn-srz5 table.skills .skillyears, .skn-srz5 table.skills .skilllast { width: 19%; } .skn-srz5 table.skills .pad1 { width: 5%; } .skn-srz5 .skills .pad2, .skn-srz5 table.skills .pad3 { width: 1%; } /*document*/ .skn-srz5 { box-sizing: border-box; color: #343434; font-variant-ligatures: none; line-height: 16px; padding-bottom: 24px; min-height: 792px; position: relative; word-wrap: break-word; } .skn-srz5 .topbgborder { bottom: -6px; height: 14px; left: 16px; position: absolute; width: 26px; } .skn-srz5 .nameSec { padding-top: 24px !important; } .skn-srz5 .nameSec .paragraph, .skn-srz5 .cntcSec .paragraph, .skn-srz5 .summary .paragraph { padding: 0; } .skn-srz5 .name { color: #fff; font-weight: 700; text-align: left; word-wrap: break-word; } .skn-srz5 .address { color: #fff; text-align: left; font-size: 0.917em; line-height: 1.25em; margin-top: 0; white-space: nowrap; position: relative; z-index: 2; } .skn-srz5 .address .txtBold { margin-right: 3px; } .skn-srz5 .addressLeft, .skn-srz5 .addressRight { width: 49%; padding: 0 1% 0 0; white-space: normal; display: inline-block; vertical-align: top; } .skn-srz5 .addressRight { padding: 0 0 0 1%; } .skn-srz5 .sectiontitle { word-wrap: break-word; } .skn-srz5 .degreeGap { margin-bottom: 4px; } .skn-srz5 .locationGap { margin-top: 4px; } .skn-srz5 .firstsection, .skn-srz5 .nameSec, .skn-srz5 .cntcSec { padding-top: 0 !important; } .skn-srz5 .education .joblocation { font-style: italic; } .skn-srz5 .resumeTitle { text-align: left; color: #fff !important; z-index: 2; position: relative; font-weight: 400; } /*leftBox and rightBox css*/ .skn-srz5 .left-box .sectiontitle { text-align: left; } /* fixes for grey border */ .skn-srz5 .left-box .section { position: relative; } .skn-srz5 .right-box { display: table-cell; letter-spacing: 0.2px; vertical-align: top; } .skn-srz5 .right-box .section { border-left: 1px solid #d5d6d6; padding-left: 23px; position: relative; } .skn-srz5 .right-box .section:first-child { padding-top: 0; } .skn-srz5 .parentContainer .section { border-left: 1px solid #d7d7d7; padding-left: 24px; padding-right: 24px; margin-left: 12px; position: relative; } .skn-srz5 .parentContainer .summary { padding-left: 0; padding-right: 0; border: none; } .skn-srz5 .heading { clear: both; color: #373d48; font-weight: bold; } /*topsection css*/ .skn-srz5 .topsection { background: #373d48; display: flex; flex-wrap: wrap; } .skn-srz5 .left-box, .skn-srz5 .right-box { display: table-cell; padding-top: 24px; padding-bottom: 15px; } .skn-srz5 .left-box { box-sizing: initial; display: table-cell; position: relative; width: 100%; } .skn-srz5 .left-box { width: 70%; flex-grow: 1; } .skn-srz5 .right-box { padding-left: 0; } .skn-srz5 .right-box .section { border: 0; padding-left: 0; } .skn-srz5 .right-box .section .icon-heading, .skn-srz5 .right-box .section:first-child .icon-heading { height: 25px; left: -8px; position: absolute; top: 3px; width: 25px; z-index: 10; } /*.skn-srz5 .icon1{opacity:.75}*/ .skn-srz5 .right-box .section .icon-heading { top: 23px; } .skn-srz5 .right-box .paddedline.date-content { position: absolute; font-weight: 700; margin-left: 0; width: 65px; } .skn-srz5 .paragraph { position: relative; clear: both; } .skn-srz5 .paragraph .singlecolumn { position: relative; } .skn-srz5 .section:empty, .skn-srz5 .hide-bar .ratingRect .noLnht, .skn-srz5 .hide-bar .field-ratt { display: none; } .skn-srz5 .right-box .education .paragraph, .skn-srz5 .right-box .experience .paragraph, .skn-srz5 .right-box .summary .paragraph { margin-left: 0; } .skn-srz5 .right-box .summary .singlecolumn { margin-left: 0 !important; } /*Timeline classes*/ .skn-srz5 .summary { border: none; margin-left: 0; padding-left: 0; padding-top: 20px !important; } .skn-srz5 .firstsection, .skn-srz5 .cntcSec { border: none; } .skn-srz5 .firstsection { padding-bottom: 0; } .skn-srz5 .heading, .skn-srz5 .singlecolumn { position: relative; } .skn-srz5 .singlecolumn:before { display: block; position: absolute; top: 0; left: -30px; content: ''; height: 9px; width: 9px; border: 0; background: #373d48; z-index: 2; transform: rotate(45deg); } .skn-srz5 .summary .singlecolumn:before { display: none; } .skn-srz5 .section.notdraggable + .section:not(.notdraggable):before { border: 3px solid #fff; content: ''; position: absolute; top: 0; left: -2px; } .skn-srz5 .paragraph + tr.paragraph:before { display: none; } .skn-srz5 .notdraggable { border: 0; } /*Icon*/ .skn-srz5 .headingIcon { left: -45px; top: -7px; position: absolute; } .skn-srz5 .headingIcon svg { height: 40px; width: 40px; position: relative; } .skn-srz5 .headingIcon svg rect { transform: rotate(45deg); fill: #373d48; } .skn-srz5 .headingIcon svg path { fill: #fff; } .skn-srz5 .ratingRect { float: right; text-align: right; } .skn-srz5 .ratingRect .noLnht { line-height: 0; } .skn-srz5 .ratingRect svg rect { transform: rotate(45deg); } .skn-srz5 .ratingfield p { display: inline; } /*common css*/ .skn-srz5 .txtBold { font-weight: bold; } .skn-srz5 .txtItl { font-style: italic; } .skn-srz5 .paddedline { display: block; } .skn-srz5 .pt5 { padding-top: 5px; } .skn-srz5 .word-break { word-wrap: break-word; } .skn-srz5 .noPind { margin-left: 0 !important; } /* Issues fix for builder page */ #displayResume .skn-srz5.document { min-height: 792px; } /* finalize page Timeline */ .skn-srz5 > div:not(.topsection), .skn-srz5 > div:not(.parentContainer) { min-height: auto; } .skn-srz5 .rating .default-fill { fill: #003d73; } .skn-srz5 .sortable-item .rating-wrapper { display: block; } /*.skn-srz5 .sortable-item .rating-wrapper > div{display:flex;position:relative;white-space:nowrap}*/ /*PICT*/ .skn-srz5 .prflPic, .skn-srz5 .prflPic > div { float: right; width: 124px; height: 124px; } .skn-srz5 .prflPic img { min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%; object-fit: cover; }</style><style> .skn-srz5, .skn-srz5 table { line-height: 16px; } .skn-srz5.pagesize { width: 825px; } .skn-srz5.fontface { font-family: Century Gothic; } .skn-srz5.fontsize { font-size: 11px; } .skn-srz5 .topsection { background: #373d48; } .skn-srz5 .section { padding-top: 20px; } .skn-srz5 .heading { padding-bottom: 10px; color: #373d48; } .skn-srz5 .jobtitle, span.degree, span.programline { font-size: 14px; } .skn-srz5 .paragraph { padding-top: 10px; } .skn-srz5 .firstparagraph { padding-top: 10px; } .skn-srz5 .photo .paragraph { padding-top: 0; } .skn-srz5 .firstparagraph .singlecolumn.maincolumn, .skn-srz5 .singlecolumn.paragraphindent { margin-left: 0; } .skn-srz5 .singlecolumn, .skn-srz5 .maincolumn { margin-left: 70px; } .skn-srz5 span.dates_wrapper { width: 70px; font-size: 11px; line-height: 17px; } .skn-srz5 .sectiontitle, .skn-srz5 .resumeTitle { font-size: 16px; line-height: 21px; } .skn-srz5 table.skills td { padding-top: 5px; } .skn-srz5 .name { font-size: 36px; line-height: 46px; } .skn-srz5 .sectiontitle { font-size: 16px; } .skn-srz5 .right-box .paragraph .singlecolumn { margin-left: 20px; } .skn-srz5 .right-box .paddedline.date-content { left: -20px; } .skn-srz5 .rating-wrapper { margin-top: 5px; } .skn-srz5 .rating-wrapper * { font-size: 11px; } .skn-srz5 .sectiontitle, .skn-srz5 .resumeTitle { font-size: 16px; line-height: 21px; } .skn-srz5 .parentContainer, .skn-srz5 .topsection { padding-left: 24px; padding-right: 24px; } .skn-srz5 .parentContainer svg.rating { padding-top: 20px; } .skn-srz5 .address { font-size: 11px; line-height: 21px; padding-top: 10px; } /*Timeline*/ .skn-srz5 .section.notdraggable + .section:not(.notdraggable):before { height: 30px; } .skn-srz5 .singlecolumn:before { background: #373d48; top: 4px; } .skn-srz5 .paragraph .dates_wrapper + .singlecolumn:before { left: -100px; } /*Icon*/ .skn-srz5 .headingIcon svg rect { fill: #373d48; } .skn-srz5 .headingIcon { top: -8px; } </style></head><body>" +
        document.getElementById("resumesec").outerHTML +
        "</body></html>";
      //const html = JSON.stringify(pdfContent);
      var file = {
        content: pdfContent,
        UserEmail: uid.user.email,
        UniqueId: self.resume.UniqueId,
        Profile: JSON.stringify(self.resume.profile),
        WorkExperience: JSON.stringify(self.resume.workExperience),
        Education: JSON.stringify(self.resume.education),
        Skills: JSON.stringify(self.resume.Skills),
        Summary: JSON.stringify(self.resume.Summary),
        ExtraFields: JSON.stringify(self.resume.extraFields),
        Purchased_Package_id: self.resume.Purchased_Package_id,
        Profile_pic: self.resume.Profile_pic,
        TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cvfilename: self.resume.profile.firstname+"_"+self.resume.profile.surname+"_"
      };
      var Url = "";
      if (self.from == "create") {
        Url = "/S3proxy/SavenewCV";
      } else {
        Url = "/S3proxy/SavetoS3";
      }
      self.loader = true;
      // let formData = new FormData();
      // const pdfBlob = await html2pdf().from(pdfContent).outputPdf();
      // const blobPartArray = await new Response(pdfBlob).arrayBuffer(); // Convert Blob to BlobPart array

      // const formData = new FormData();
      // formData.append('file', new Blob([blobPartArray]), 'output.pdf');

      // formData.append('pdfFile', pdfBlob, 'output.pdf');
      axios({
        method: "post",
          url: rest_service.baseURL + Url,
        //url: "https://localhost:7101/api" + Url,
        data: file,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + uid.returnedToken
        }
      })
        .then(function(response) {
          if (response) {
            self.loader = false;
            self.closePopUp("goBack");
            self.$router.push({
              path: "/dashboard"
            });
            self.sucessmsgtext = "CV saved successfully";
            self.isdisplaymsg = true;
            setTimeout(xy => {
              self.closeMessage();
            }, 5000);
            debugger;
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
      //const pdfBuffer =  pdfBlob.arrayBuffer();
      //   const s3 = new AWS.S3({
      //   accessKeyId: 'AKIA5BLF7Z4HNIYBATMF',
      //   secretAccessKey: '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',
      //   region: 'us-east-1',
      // });

      // // Define S3 upload parameters
      // const params = {
      //   Bucket: 'documents-gen-ehr-dev',
      //   Key: 'shri@mailinator.com/document.pdf', // Desired name for the uploaded file
      //   Body: pdfBlob,
      //   ContentType: 'application/pdf',
      //   ACL: 'private',
      // };

      // // Upload to S3
      // s3.upload(params, (error, data) => {
      //   if (error) {
      //     console.error('Error uploading to S3:', error);
      //   } else {
      //     console.log('PDF uploaded to S3:', data.Location);
      //   }
      // });
      //  html2pdf(document.getElementById("resumesec"), {
      // 		margin: 1,
      // 	filename: "i-was-html.pdf",
      // 	});
    }
  }
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: table;
  transition: opacity 0.3s ease-in-out;
}
/* .modal-wrapper {
  display: table-cell;
  vertical-align: middle;
} */
.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 50px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: opacity 0.5s ease-in-out;
}
.modal-mask.upl-holdNEW.wdth-700 .modal-container {
  width: 700px;
}

.modal-mask:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-wrapper {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  width: 100%;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" id="static">
/*Font support for MAC*/

@font-face {
  font-family: "Century Gothic";
  font-weight: normal;
  font-style: normal;
  src: local("Century Gothic"),
    url("/blobcontent/zty/fonts/CenturyGothic.ttf") format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  font-weight: bold;
  font-style: normal;
  src: local("Century Gothic Bold"),
    url("/blobcontent/zty/fonts/CenturyGothicBold.ttf") format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  font-weight: bold;
  font-style: italic;
  src: local("Century Gothic Bold Italic"),
    url("/blobcontent/zty/fonts/CenturyGothicBoldItalic.ttf") format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  font-weight: normal;
  font-style: italic;
  src: local("Century Gothic Italic"),
    url("/blobcontent/zty/fonts/CenturyGothicItalic.ttf") format("truetype");
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  vertical-align: baseline;
  background: transparent;
}
body {
  text-align: left;
  font-feature-settings: "liga" 0;
  -moz-font-feature-settings: "liga" off;
}
.skn-srz5 ol,
.skn-srz5 ul {
  list-style: none;
}
.skn-srz5 table {
  border-collapse: collapse;
  border-spacing: 0;
  font-size: inherit;
  color: inherit;
  width: 100%;
}

/*START content disc style for LI*/
.skn-srz5 ul,
.skn-srz5 li {
  margin: 0;
  padding: 0;
  list-style-type: disc;
}
.skn-srz5 ul li {
  margin: 0 0 0 16px;
  padding: 0;
}
@-moz-document url-prefix() {
  .skn-srz5 ul li {
    margin: 0 0 0 12px;
    padding: 0 0 0 3px;
  }
}
/*END content disc style for LI*/

.skn-srz5 span.paddedline {
  display: block;
}
.skn-srz5 span.jobtitle,
.skn-srz5 span.degree,
.skn-srz5 span.programline {
  font-weight: bold;
}
.skn-srz5 .pb5 {
  padding-bottom: 5px;
}
.skn-srz5 span.dates_wrapper {
  font-weight: bold;
  display: block;
  float: left;
  text-align: left;
  padding-right: 10px;
  box-sizing: border-box;
}
.skn-srz5 .txtItalics {
  font-style: italic;
}
.skn-srz5 .txtBold {
  font-weight: bold;
}

/*table style*/
.skn-srz5 table.skills,
.table_wrapper {
  width: 100%;
  margin-top: 0;
  word-wrap: break-word;
}
.skn-srz5 table.skills th,
table.skills td {
  width: 20%;
  text-align: center;
}
.skn-srz5 table.skills .skillname,
.skn-srz5 table.skills .skillrating {
  text-align: left;
  width: 35%;
}
.skn-srz5 table.skills .skillrating {
  width: 20%;
}
.skn-srz5 table.skills .skillyears,
.skn-srz5 table.skills .skilllast {
  width: 19%;
}
.skn-srz5 table.skills .pad1 {
  width: 5%;
}
.skn-srz5 .skills .pad2,
.skn-srz5 table.skills .pad3 {
  width: 1%;
}

/*document*/
.skn-srz5 {
  box-sizing: border-box;
  color: #343434;
  font-variant-ligatures: none;
  line-height: 16px;
  padding-bottom: 24px;
  min-height: 792px;
  position: relative;
  word-wrap: break-word;
}
.skn-srz5 .topbgborder {
  bottom: -6px;
  height: 14px;
  left: 16px;
  position: absolute;
  width: 26px;
}
.skn-srz5 .nameSec {
  padding-top: 24px !important;
}
.skn-srz5 .nameSec .paragraph,
.skn-srz5 .cntcSec .paragraph,
.skn-srz5 .summary .paragraph {
  padding: 0;
}

.skn-srz5 .name {
  color: #fff;
  font-weight: 700;
  text-align: left;
  word-wrap: break-word;
}
.skn-srz5 .address {
  color: #fff;
  text-align: left;
  font-size: 0.917em;
  line-height: 1.25em;
  margin-top: 0;
  white-space: nowrap;
  position: relative;
  z-index: 2;
}
.skn-srz5 .address .txtBold {
  margin-right: 3px;
}
.skn-srz5 .addressLeft,
.skn-srz5 .addressRight {
  width: 49%;
  padding: 0 1% 0 0;
  white-space: normal;
  display: inline-block;
  vertical-align: top;
}
.skn-srz5 .addressRight {
  padding: 0 0 0 1%;
}
.skn-srz5 .sectiontitle {
  word-wrap: break-word;
}
.skn-srz5 .degreeGap {
  margin-bottom: 4px;
}
.skn-srz5 .locationGap {
  margin-top: 4px;
}
.skn-srz5 .firstsection,
.skn-srz5 .nameSec,
.skn-srz5 .cntcSec {
  padding-top: 0 !important;
}
.skn-srz5 .education .joblocation {
  font-style: italic;
}
.skn-srz5 .resumeTitle {
  text-align: left;
  color: #fff !important;
  z-index: 2;
  position: relative;
  font-weight: 400;
}

/*leftBox and rightBox css*/
.skn-srz5 .left-box .sectiontitle {
  text-align: left;
}

/* fixes for grey border */
.skn-srz5 .left-box .section {
  position: relative;
}

.skn-srz5 .right-box {
  display: table-cell;
  letter-spacing: 0.2px;
  vertical-align: top;
}
.skn-srz5 .right-box .section {
  border-left: 1px solid #d5d6d6;
  padding-left: 23px;
  position: relative;
}
.skn-srz5 .right-box .section:first-child {
  padding-top: 0;
}
.skn-srz5 .parentContainer .section {
  border-left: 1px solid #d7d7d7;
  padding-left: 24px;
  padding-right: 24px;
  margin-left: 12px;
  position: relative;
}
.skn-srz5 .parentContainer .summary {
  padding-left: 0;
  padding-right: 0;
  border: none;
}
.skn-srz5 .heading {
  clear: both;
  color: #373d48;
  font-weight: bold;
}

/*topsection css*/
.skn-srz5 .topsection {
  background: #373d48;
  display: flex;
  flex-wrap: wrap;
}
.skn-srz5 .left-box,
.skn-srz5 .right-box {
  display: table-cell;
  padding-top: 24px;
  padding-bottom: 15px;
}
.skn-srz5 .left-box {
  box-sizing: initial;
  display: table-cell;
  position: relative;
  width: 100%;
}
.skn-srz5 .left-box {
  width: 70%;
  flex-grow: 1;
}
.skn-srz5 .right-box {
  padding-left: 0;
}
.skn-srz5 .right-box .section {
  border: 0;
  padding-left: 0;
}
.skn-srz5 .right-box .section .icon-heading,
.skn-srz5 .right-box .section:first-child .icon-heading {
  height: 25px;
  left: -8px;
  position: absolute;
  top: 3px;
  width: 25px;
  z-index: 10;
}
/*.skn-srz5 .icon1{opacity:.75}*/
.skn-srz5 .right-box .section .icon-heading {
  top: 23px;
}
.skn-srz5 .right-box .paddedline.date-content {
  position: absolute;
  font-weight: 700;
  margin-left: 0;
  width: 65px;
}
.skn-srz5 .paragraph {
  position: relative;
  clear: both;
}
.skn-srz5 .paragraph .singlecolumn {
  position: relative;
}
.skn-srz5 .section:empty,
.skn-srz5 .hide-bar .ratingRect .noLnht,
.skn-srz5 .hide-bar .field-ratt {
  display: none;
}
.skn-srz5 .right-box .education .paragraph,
.skn-srz5 .right-box .experience .paragraph,
.skn-srz5 .right-box .summary .paragraph {
  margin-left: 0;
}
.skn-srz5 .right-box .summary .singlecolumn {
  margin-left: 0 !important;
}

/*Timeline classes*/
.skn-srz5 .summary {
  border: none;
  margin-left: 0;
  padding-left: 0;
  padding-top: 20px !important;
}
.skn-srz5 .firstsection,
.skn-srz5 .cntcSec {
  border: none;
}
.skn-srz5 .firstsection {
  padding-bottom: 0;
}
.skn-srz5 .heading,
.skn-srz5 .singlecolumn {
  position: relative;
}
.skn-srz5 .singlecolumn:before {
  display: block;
  position: absolute;
  top: 0;
  left: -30px;
  content: "";
  height: 9px;
  width: 9px;
  border: 0;
  background: #373d48;
  z-index: 2;
  transform: rotate(45deg);
}
.skn-srz5 .summary .singlecolumn:before {
  display: none;
}
.skn-srz5 .section.notdraggable + .section:not(.notdraggable):before {
  border: 3px solid #fff;
  content: "";
  position: absolute;
  top: 0;
  left: -2px;
}
.skn-srz5 .paragraph + tr.paragraph:before {
  display: none;
}
.skn-srz5 .notdraggable {
  border: 0;
}

/*Icon*/
.skn-srz5 .headingIcon {
  left: -45px;
  top: -7px;
  position: absolute;
}
.skn-srz5 .headingIcon svg {
  height: 40px;
  width: 40px;
  position: relative;
}

.skn-srz5 .headingIcon svg rect {
  transform: rotate(45deg);
  fill: #373d48;
}
.skn-srz5 .headingIcon svg path {
  fill: #fff;
}
.skn-srz5 .ratingRect {
  float: right;
  text-align: right;
}
.skn-srz5 .ratingRect .noLnht {
  line-height: 0;
}
.skn-srz5 .ratingRect svg rect {
  transform: rotate(45deg);
}
.skn-srz5 .ratingfield p {
  display: inline;
}

/*common css*/
.skn-srz5 .txtBold {
  font-weight: bold;
}
.skn-srz5 .txtItl {
  font-style: italic;
}
.skn-srz5 .paddedline {
  display: block;
}
.skn-srz5 .pt5 {
  padding-top: 5px;
}
.skn-srz5 .word-break {
  word-wrap: break-word;
}
.skn-srz5 .noPind {
  margin-left: 0 !important;
}

/* Issues fix for builder page */
#displayResume .skn-srz5.document {
  min-height: 792px;
}

/* finalize page Timeline */
.skn-srz5 > div:not(.topsection),
.skn-srz5 > div:not(.parentContainer) {
  min-height: auto;
}
.skn-srz5 .rating .default-fill {
  fill: #003d73;
}
.skn-srz5 .sortable-item .rating-wrapper {
  display: block;
}
/*.skn-srz5 .sortable-item .rating-wrapper > div{display:flex;position:relative;white-space:nowrap}*/

/*PICT*/
.skn-srz5 .prflPic,
.skn-srz5 .prflPic > div {
  float: right;
  width: 124px;
  height: 124px;
}
.skn-srz5 .prflPic img {
  min-width: 100%;
  max-width: 100%;
  min-height: 100%;
  max-height: 100%;
  object-fit: cover;
}
</style>
				<style>
.skn-srz5,
.skn-srz5 table {
  line-height: 16px;
}
.skn-srz5.pagesize {
  /* width: 825px; */
  width: 100%;
}
.skn-srz5.fontface {
  font-family: Century Gothic;
}
.skn-srz5.fontsize {
  font-size: 11px;
}
.skn-srz5 .topsection {
  background: #373d48;
}
.skn-srz5 .section {
  padding-top: 20px;
}
.skn-srz5 .heading {
  padding-bottom: 10px;
  color: #373d48;
}
.skn-srz5 .jobtitle,
span.degree,
span.programline {
  font-size: 14px;
}
.skn-srz5 .paragraph {
  padding-top: 10px;
}
.skn-srz5 .firstparagraph {
  padding-top: 10px;
}
.skn-srz5 .photo .paragraph {
  padding-top: 0;
}
.skn-srz5 .firstparagraph .singlecolumn.maincolumn,
.skn-srz5 .singlecolumn.paragraphindent {
  margin-left: 0;
}
.skn-srz5 .singlecolumn,
.skn-srz5 .maincolumn {
  margin-left: 70px;
}
.skn-srz5 span.dates_wrapper {
  width: 70px;
  font-size: 11px;
  line-height: 17px;
}
.skn-srz5 .sectiontitle,
.skn-srz5 .resumeTitle {
  font-size: 16px;
  line-height: 21px;
}
.skn-srz5 table.skills td {
  padding-top: 5px;
}
.skn-srz5 .name {
  font-size: 36px;
  line-height: 46px;
}
.skn-srz5 .sectiontitle {
  font-size: 16px;
}
.skn-srz5 .right-box .paragraph .singlecolumn {
  margin-left: 20px;
}
.skn-srz5 .right-box .paddedline.date-content {
  left: -20px;
}
.skn-srz5 .rating-wrapper {
  margin-top: 5px;
}
.skn-srz5 .rating-wrapper * {
  font-size: 11px;
}
.skn-srz5 .sectiontitle,
.skn-srz5 .resumeTitle {
  font-size: 16px;
  line-height: 21px;
}
.skn-srz5 .parentContainer,
.skn-srz5 .topsection {
  padding-left: 24px;
  padding-right: 24px;
}
.skn-srz5 .parentContainer svg.rating {
  padding-top: 20px;
}
.skn-srz5 .address {
  font-size: 11px;
  line-height: 21px;
  padding-top: 10px;
}
/*Timeline*/
.skn-srz5 .section.notdraggable + .section:not(.notdraggable):before {
  height: 30px;
}
.skn-srz5 .singlecolumn:before {
  background: #373d48;
  top: 4px;
}
.skn-srz5 .paragraph .dates_wrapper + .singlecolumn:before {
  left: -100px;
}

/*Icon*/
.skn-srz5 .headingIcon svg rect {
  fill: #373d48;
}
.skn-srz5 .headingIcon {
  top: -8px;
}
</style>
